// Admin Management Permissions

export const ADMINS_INDEX = 24;
export const ADMINS_CREATE = 25;
export const ADMINS_EDIT = 26;
export const ADMINS_DELETE = 27;
// There is no admin detail endpoint; the profile is read through the list permission.
export const ADMINS_SHOW = ADMINS_INDEX;
export const ADMINS_RESTORE = 1378;
